import { Button } from 'antd'
import { FC } from 'react'
import FormModal from '../../../../components/form-modal/form-modal'
import RibbonForm from '../ribbon-form/ribbon-form'

interface CreateRibbonProps {
    onSuccess: () => void
}

const CreateRibbon: FC<CreateRibbonProps> = ({ onSuccess }) => {
    return (
        <FormModal
            width={480}
            title='Новый риббон'
            renderOpener={onOpen => (
                <Button type='primary' onClick={onOpen}>
                    Создать
                </Button>
            )}
            renderContent={onClose => (
                <RibbonForm onSuccess={onSuccess} onClose={onClose} />
            )}
        />
    )
}

export default CreateRibbon
